/* SARATTI — Loose Gemstones collection · behaviour
   Filtering and paging stay Shopify-native: every option and every page is a
   real URL. Paging is progressive enhancement on top of that — the numbered
   pager is still rendered and still works with JS off. Nothing is fetched
   until the visitor asks: the first page is fetched only once the visitor has
   actually scrolled toward the end of the grid, and a scroll-progress guard
   caps how many pages can arrive without them moving, so the visitor is never
   handed a runaway fetch loop on a phone. A "Load more stones" button is
   always available as the escape hatch. */
(function () {
  'use strict';

  /* ---------- filter dropdowns ---------- */
  function initDropdowns(scope) {
    var dds = (scope || document).querySelectorAll('.lg .dd:not([data-lg-dd])');
    Array.prototype.forEach.call(dds, function (dd) {
      dd.setAttribute('data-lg-dd', '1');
      var btn = dd.querySelector('.ddBtn');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var wasOpen = dd.classList.contains('on');
        closeAll();
        if (!wasOpen) { dd.classList.add('on'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
  }
  function closeAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.lg .dd.on'), function (d) {
      d.classList.remove('on');
      var b = d.querySelector('.ddBtn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- read more ---------- */
  function initMore(scope) {
    var btns = (scope || document).querySelectorAll('[data-lg-more]:not([data-lg-more-init])');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.setAttribute('data-lg-more-init', '1');
      btn.addEventListener('click', function () {
        var host = btn.closest('.chero');
        if (!host) return;
        var open = host.classList.toggle('open');
        btn.textContent = open ? (btn.getAttribute('data-less') || 'Read less')
                               : (btn.getAttribute('data-more') || 'Read more');
      });
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq(scope) {
    var qs = (scope || document).querySelectorAll('.lg .q:not([data-lg-q])');
    Array.prototype.forEach.call(qs, function (q) {
      q.setAttribute('data-lg-q', '1');
      q.addEventListener('click', function () {
        var qa = q.closest('.qa');
        if (!qa) return;
        var open = qa.classList.contains('on');
        Array.prototype.forEach.call(qa.parentNode.querySelectorAll('.qa.on'), function (s) {
          s.classList.remove('on');
        });
        if (!open) qa.classList.add('on');
        q.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  /* ---------- sticky header offset ---------- */
  /* The rail pins directly beneath the site header. The theme does publish a
     --header-height, but two different writers set it and one of them adds the
     announcement bar, which is not sticky - so the value is not trustworthy as
     a pin offset. Measure the element that actually pins, .cc-header, and
     publish it as --lg-head. Falls back to 0 if the header is not found. */
  var headInited = false;
  var headH = 0;       /* last measured header height - remembered while hidden */
  var navOff = false;  /* true while the header is slid out of the way */

  function lgHeaderEl() {
    return document.querySelector('.cc-header')
      || document.querySelector('store-header')
      || document.getElementById('shopify-section-header');
  }

  /* Publishing is split from measuring so the scroll handler can flip the
     offset to 0 without losing the height it has to put back on the way up,
     and so a resize while hidden still records the new height. */
  function applyHeadVar() {
    document.documentElement.style.setProperty('--lg-head', (navOff ? 0 : headH) + 'px');
  }

  function setHeadVar() {
    var h = lgHeaderEl();
    headH = h ? h.offsetHeight : 0;
    applyHeadVar();
  }

  function lgDebounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait || 150);
    };
  }

  function initHeadVar() {
    if (headInited) return;
    headInited = true;
    setHeadVar();
    window.addEventListener('resize', lgDebounce(setHeadVar, 150));
    window.addEventListener('load', setHeadVar);
    /* the header collapses its menu row on scroll, so a single measurement
       goes stale - observe it where ResizeObserver is available */
    if ('ResizeObserver' in window) {
      var h = lgHeaderEl();
      if (h) new ResizeObserver(lgDebounce(setHeadVar, 60)).observe(h);
    }
  }

  /* ---------- hide the header on scroll-down ----------
     Collection page only: the rail is the thing worth pinning once you are
     reading the grid, and the header above it is just lost height. Guarded on
     .lg so no other template's header behaviour changes. Reads are batched
     into one rAF callback, so a scroll burst costs a single layout query. */
  var navInited = false;

  function initNavHide() {
    if (navInited) return;
    if (!document.querySelector('.lg')) return;
    navInited = true;

    var THRESHOLD = 200;  /* px scrolled before the header may leave at all */
    var DELTA = 6;        /* ignore jitter, momentum overscroll and rubber-band */
    var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var ticking = false;
    var raf = window.requestAnimationFrame
      ? window.requestAnimationFrame.bind(window)
      : function (fn) { return setTimeout(fn, 16); };

    function frame() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (y < 0) y = 0;
      var diff = y - lastY;
      if (Math.abs(diff) < DELTA) return;   /* keep lastY as the last real position */
      lastY = y;
      var want = y > THRESHOLD && diff > 0;
      if (want === navOff) return;
      navOff = want;
      document.documentElement.classList.toggle('lg-nav-off', navOff);
      applyHeadVar();
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      raf(frame);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- floating bar ---------- */
  function initFbar() {
    var bar = document.querySelector('.lg-fbar');
    var rail = document.querySelector('.lg-rail');
    if (!bar || !rail || bar.dataset.lgFbar === '1') return;
    bar.dataset.lgFbar = '1';
    function sync() { bar.classList.toggle('show', rail.getBoundingClientRect().bottom < 0); }
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    var top = bar.querySelector('[data-lg-top]');
    if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- paging: auto-load, with a button that never goes away ----------
     Scroll-driven loading was tried four times and abandoned twice over, for
     two distinct reasons. Both are answered here, explicitly:

       1. RUNAWAY. Auto-loading from the first paint once fetched 21 pages -
          504 cards - inside a second, which is ruinous on a phone. A `busy`
          flag alone does not stop that: each page settles, the sentinel is
          still on screen because the cards have not filled the viewport, and
          the next load starts legitimately. So there is a second, harder
          guard - SCROLL PROGRESS. Every auto-load records window.scrollY at
          the moment it starts. If an auto-load is about to fire and the
          visitor has not moved at least SCROLL_MIN px since the previous one,
          that is a stall; STALL_LIMIT consecutive stalls turn auto-loading
          off for the rest of the session and hand control back to the button.
          Chained loads are therefore bounded at STALL_LIMIT + 1 no matter how
          fast the network is, so "21 pages in a second" cannot happen.

       2. NEVER RESUMED. An IntersectionObserver reports *changes* of
          intersection state. The old sentinel lived inside the load-more
          wrapper, which clearWrap() empties and finish() removes, so the
          observed node was destroyed and the observation went with it; and
          even when it survived, after the first load the sentinel was already
          inside the root margin, no new crossing ever occurred, and nothing
          fired again. The fix is two-part: ONE sentinel, created once,
          appended to the grid once, never cleared and never re-created, and
          observed exactly once - and after every successful append the code
          re-measures the sentinel itself (getBoundingClientRect) rather than
          waiting for a crossing that will never come, and starts the next
          load itself if it is still in range.

     Nothing is fetched on initial paint. The first auto-load additionally
     requires that a real scroll event has happened, so a short collection on
     a tall screen sits still until the visitor actually moves.

     The "Load more stones" button is rendered for as long as there is a next
     page, in every mode. In auto mode it is rarely needed, but it is the
     escape hatch: if auto-loading is off, stops, never starts, or the browser
     has no IntersectionObserver, the visitor is never stranded.

     The numbered pager is hidden for the whole session: a network hiccup is a
     reason to click again, never a reason to drop the visitor back onto
     "1 2 3 ... 35". */
  function initInfinite() {
    var grid = document.querySelector('.lg .grid[data-lg-next]');
    if (!grid || grid.dataset.lgInf === '1') return;

    grid.dataset.lgInf = '1';

    var pager = document.querySelector('.lg .pager');
    if (pager) pager.classList.add('hidden');

    var loadingText = grid.getAttribute('data-lg-loading') || 'Loading more stones';
    var moreText = grid.getAttribute('data-lg-more-label') || 'Load more stones';

    /* auto | auto_then_button | button - set from the section setting. */
    var mode = grid.getAttribute('data-lg-paging') || 'auto';
    var autoBudget = parseInt(grid.getAttribute('data-lg-auto-pages'), 10);
    if (!(autoBudget > 0)) autoBudget = 4;

    /* How far below the fold the sentinel may be and still count as "near".
       Used both as the observer's rootMargin and as the number the manual
       re-measure compares against, so the two can never disagree. */
    var ROOT_MARGIN = 800;
    /* Minimum scroll between two consecutive auto-loads before the second one
       counts as a stall. Roughly one card row on a phone. */
    var SCROLL_MIN = 300;
    /* Consecutive stalls tolerated before auto-loading gives up. Two, not
       one: the first stall is legitimate - a page whose cards do not fill the
       viewport leaves the sentinel in view with nothing for the visitor to
       scroll to, and refusing to load there would strand them mid-grid. A
       second consecutive stall means pages are arriving faster than they can
       be read, which is the runaway signature, so auto stops there. The hard
       consequence is that at most STALL_LIMIT + 1 = 3 pages can ever be
       fetched without the visitor moving. */
    var STALL_LIMIT = 2;

    /* Backoff ladder for the one automatic retry a failed fetch is allowed.
       The same url is retried - a 429, a cold cache or a momentary
       interstitial all clear on their own given a few seconds. If the retry
       fails too, control goes back to the button and the visitor clicks. */
    var DELAYS = [800, 2000, 4000, 8000, 15000];
    var MAX_FAILS = 6;

    var busy = false;
    var fails = 0;
    var retried = false;   /* an automatic retry has already been spent on this run */

    var autoOn = mode !== 'button' && 'IntersectionObserver' in window;
    var autoUsed = 0;      /* auto-loads performed so far */
    var lastAutoY = null;  /* window.scrollY when the previous auto-load started */
    var stalls = 0;        /* consecutive auto-loads with no real scroll between */
    var scrolled = false;  /* a real scroll event has happened */
    var io = null;
    var ticking = false;

    /* The wrapper lives at the end of the grid for as long as there is a next
       page. It holds either the button or the loading label, never both, and
       new cards are inserted before it so it stays last. */
    var wrap = document.createElement('div');
    wrap.className = 'lg-loadmore';

    /* Polite live region. Kept out of the wrapper on purpose: the wrapper is
       emptied and removed, and a live region has to persist to be announced.
       Nothing here ever takes focus. */
    var live = document.createElement('div');
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('aria-atomic', 'true');
    live.className = 'lg-live';
    live.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;grid-column:1/-1;';
    grid.appendChild(live);

    /* THE persistent sentinel. Created once, appended once, observed once,
       and never touched by clearWrap() or finish(). It is a full-width,
       1px-tall grid item so it always sits on its own after the last card and
       never eats a column. */
    var sentinel = null;
    if (autoOn) {
      sentinel = document.createElement('div');
      sentinel.className = 'lg-sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'grid-column:1/-1;width:100%;height:1px;margin:0;padding:0;pointer-events:none;';
      grid.appendChild(sentinel);
    }

    function nextUrl() { return grid.getAttribute('data-lg-next'); }

    function scrollY() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function sameOrigin(u) {
      try { return new URL(u, window.location.href).origin === window.location.origin; }
      catch (err) { return false; }
    }

    function clearWrap() {
      while (wrap.firstChild) wrap.removeChild(wrap.firstChild);
    }

    /* Keep the wrapper, then the sentinel, as the last two children, so new
       cards never land after them. */
    function tail() {
      if (wrap.parentNode !== grid) grid.appendChild(wrap);
      if (sentinel && sentinel.parentNode === grid) grid.appendChild(sentinel);
    }

    /* Nothing left to fetch: take the wrapper out of the document entirely
       and stop observing. The sentinel is left where it is - it is 1px tall,
       invisible, and removing it is exactly the mistake that broke this
       before. */
    function finish() {
      clearWrap();
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
      stopAuto(null);
    }

    /* Auto-loading is over. Every caller must leave the visitor with a way
       forward, so unless a fetch is in flight the button goes back up. */
    function stopAuto(reason) {
      autoOn = false;
      if (io) { io.disconnect(); io = null; }
      if (reason) {
        console.info('[LG] auto-loading off, falling back to the button', { reason: reason });
        if (!busy) showLoadMore();
      }
    }

    function showLoadMore() {
      if (!nextUrl()) { finish(); return; }
      clearWrap();
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'btn';
      b.textContent = moreText;
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        retried = false;
        fails = 0;
        load();
      });
      wrap.appendChild(b);
      tail();
    }

    function showLoading() {
      clearWrap();
      var note = document.createElement('div');
      note.className = 'lg-loading';
      note.textContent = loadingText;
      wrap.appendChild(note);
      tail();
      live.textContent = loadingText;
    }

    /* Is the sentinel inside the viewport plus the root margin right now?
       This is the half of the fix that makes the observer resume: after an
       append the sentinel may already be inside the margin, in which case no
       further crossing will ever be reported and the observer would sit there
       forever. Asking the geometry directly does not depend on a crossing. */
    function sentinelNear() {
      if (!sentinel || !sentinel.isConnected) return false;
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      return sentinel.getBoundingClientRect().top <= vh + ROOT_MARGIN;
    }

    /* The single entry point for every automatic load: the observer, the
       scroll handler and the post-append re-check all come through here, so
       the guards cannot be bypassed by any one of them. */
    function maybeAuto() {
      if (!autoOn || busy) return;
      if (!grid.isConnected) { stopAuto(null); return; }
      if (!nextUrl()) { finish(); return; }
      /* Nothing is fetched until the visitor has actually scrolled. */
      if (!scrolled) return;
      if (mode === 'auto_then_button' && autoUsed >= autoBudget) {
        stopAuto('auto page budget of ' + autoBudget + ' reached');
        return;
      }
      if (!sentinelNear()) return;

      var y = scrollY();
      if (lastAutoY !== null && Math.abs(y - lastAutoY) < SCROLL_MIN) {
        stalls++;
        if (stalls >= STALL_LIMIT) {
          stopAuto('no scroll progress: ' + stalls + ' consecutive auto-loads under ' + SCROLL_MIN + 'px');
          return;
        }
      } else {
        stalls = 0;
      }

      lastAutoY = y;
      autoUsed++;
      retried = false;
      load();
    }

    function onScroll() {
      scrolled = true;
      if (ticking) return;
      ticking = true;
      (window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); })(function () {
        ticking = false;
        maybeAuto();
      });
    }

    function load() {
      var url = nextUrl();
      if (busy || !url) return;
      busy = true;
      showLoading();

      var settled = false;
      var res0 = null;

      function fail() {
        if (settled) return;
        settled = true;
        busy = false;
        fails++;
        /* One automatic retry per run, on the backoff ladder. After that the
           button comes back and the visitor decides whether to try again. */
        if (!retried && fails < MAX_FAILS) {
          retried = true;
          setTimeout(load, DELAYS[Math.min(fails - 1, DELAYS.length - 1)]);
          return;
        }
        /* Repeated failures are a reason to stop fetching on the visitor's
           behalf, never a reason to leave them with nothing. */
        if (autoOn && fails >= 3) stopAuto('repeated fetch failures');
        showLoadMore();
      }

      function succeed() {
        settled = true;
        busy = false;
        fails = 0;
      }

      function diag(extra) {
        var d = {
          url: url,
          status: res0 ? res0.status : 0,
          redirected: res0 ? res0.redirected : false,
          finalUrl: res0 ? res0.url : ''
        };
        if (extra) { for (var k in extra) { if (extra.hasOwnProperty(k)) d[k] = extra[k]; } }
        return d;
      }

      fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (res) {
          res0 = res;
          if (!grid.isConnected) { succeed(); return ''; }
          if (!res.ok) {
            console.warn('[LG] page fetch returned a non-OK status', diag());
          }
          /* Shopify will 302 a paged collection url around (locale, market,
             primary domain). Following it is fine as long as we land back on
             this origin; anything else is a challenge page or an interstitial
             and the html is worthless. */
          if (res.redirected && !sameOrigin(res.url)) {
            console.warn('[LG] page fetch redirected off-origin', diag());
            throw new Error('off-origin redirect');
          }
          return res.text();
        })
        .then(function (text) {
          /* The grid this closure was built around may have been thrown away
             while the request was in flight - a filter tap replaces the whole
             of #filter-results. Appending into a detached node loses the cards
             silently, so bail out and let the newly booted pager take over. */
          if (!grid.isConnected) { succeed(); stopAuto(null); return; }

          var doc = new DOMParser().parseFromString(text, 'text/html');
          var incoming = doc.querySelector('.lg .grid[data-lg-next], .lg .grid');

          if (!incoming) {
            /* The single most useful line in this file. If the storefront is
               serving a bot-verification interstitial instead of the
               collection, the snippet says so outright. */
            console.warn('[LG] page fetch produced no grid', diag({
              length: text.length,
              snippet: text.slice(0, 200)
            }));
            fail();
            return;
          }

          var cards = incoming.querySelectorAll(':scope > .lgc, :scope > .promo');
          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(cards, function (c) { frag.appendChild(c); });

          succeed();

          if (wrap.parentNode === grid) grid.insertBefore(frag, wrap);
          else if (sentinel && sentinel.parentNode === grid) grid.insertBefore(frag, sentinel);
          else grid.appendChild(frag);
          tail();

          /* Screen readers are told the stones arrived. Focus is untouched. */
          live.textContent = cards.length + ' more stones loaded';

          var next = incoming.getAttribute('data-lg-next');
          if (!next || next === url) {
            grid.removeAttribute('data-lg-next');
            finish();
            return;
          }

          grid.setAttribute('data-lg-next', next);
          /* The button comes straight back, ready for the next page and there
             to be clicked if auto-loading is off or stops. */
          showLoadMore();

          /* Re-arm by measurement, not by waiting for a crossing. If the new
             cards did not push the sentinel past the root margin, no
             intersection change will ever be reported, so ask the geometry
             and start the next load here. The scroll-progress guard inside
             maybeAuto() is what keeps this from becoming a loop. */
          if (autoOn) setTimeout(maybeAuto, 0);
        })
        .catch(function (err) {
          console.warn('[LG] page fetch failed', diag({
            error: String((err && err.message) || err)
          }));
          fail();
        });
    }

    /* Opening state: nothing fetched, one button at the end of the grid. */
    showLoadMore();

    if (autoOn) {
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { maybeAuto(); return; }
        }
      }, { root: null, rootMargin: '0px 0px ' + ROOT_MARGIN + 'px 0px', threshold: 0 });
      io.observe(sentinel);
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', lgDebounce(function () { if (scrolled) maybeAuto(); }, 150));
    }
  }

  /* ---------- mobile facet drawer ----------
     At 860px and below the custom rail is hidden and filtering happens in the
     theme's own <facet-filters> drawer, which slides in from the left and
     updates the results over AJAX. Three jobs here, and only three - the
     drawer's own behaviour belongs to the theme and is not touched:

       1. open it from the "Filter & sort" button, using the same contract
          products-toolbar.js uses: call the element's own open(opener), which
          is SideDrawer.open, so focus trapping, the overlay and the scroll
          lock all behave exactly as they do for every other drawer;
       2. keep the button's badge and result count honest, because the button
          sits outside #filter-results and is therefore not part of the swap;
       3. re-boot after every swap, because the swap destroys the
          .grid[data-lg-next] node the pager below is bound to.

     boot() is safe to call again: every sub-init is guarded, either by a
     module-level flag (header offset, nav hide) or by a marker attribute on
     the node itself (dropdowns, read more, FAQ, floating bar, and the grid's
     own data-lg-inf). A second call over the same DOM is a no-op; over a
     replaced grid it re-arms the pager and nothing else. */

  function lgDrawer() { return document.querySelector('facet-filters'); }

  function lgOpener() { return document.querySelector('[data-lgf-open]'); }

  function syncFacetOpener() {
    var btn = lgOpener();
    if (!btn) return;

    /* The applied-filter chips are inside #facets, which the swap does
       refresh, so counting them is always current. */
    var n = document.querySelectorAll('#facets .active-filters .active-filter').length;
    var badge = btn.querySelector('[data-lgf-count]');
    if (badge) {
      badge.textContent = String(n);
      if (n > 0) badge.removeAttribute('hidden');
      else badge.setAttribute('hidden', '');
    }

    /* The drawer's own "Show N results" button is relabelled by the theme on
       every swap - the one place the fresh count is guaranteed to be. */
    var out = btn.querySelector('[data-lgf-results]');
    var close = document.querySelector('.js-close-drawer-mob');
    if (out && close) {
      var m = (close.innerText || '').match(/[\d][\d.,]*/);
      if (m) out.textContent = m[0] + ' ' + (out.getAttribute('data-lgf-word') || '');
    }
  }

  function initFacetOpener(scope) {
    var btns = (scope || document).querySelectorAll('[data-lgf-open]:not([data-lgf-init])');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.setAttribute('data-lgf-init', '1');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();   /* the document click handler closes rail dropdowns */
        var d = lgDrawer();
        if (!d || typeof d.open !== 'function') return;
        btn.setAttribute('aria-expanded', 'true');
        d.open(btn);
      });
    });
  }

  var facetsWired = false;

  function initFacetEvents() {
    if (facetsWired) return;
    if (!document.querySelector('facet-filters')) return;
    facetsWired = true;

    document.addEventListener('on:facet-filters:after-open', function () {
      var b = lgOpener();
      if (b) b.setAttribute('aria-expanded', 'true');
    });
    document.addEventListener('on:facet-filters:after-close', function () {
      var b = lgOpener();
      if (b) b.setAttribute('aria-expanded', 'false');
    });

    /* The swap replaced #filter-results wholesale. Re-arm the pager, then
       bring the opener's badge and count back in line. */
    document.addEventListener('on:facet-filters:updated', function () {
      boot(document);
      syncFacetOpener();
    });

    /* Above 860px the drawer is display:none. If the viewport crosses that
       line while it is open - a phone turned landscape - the theme never
       closes it, and the body is left scroll-locked with nothing on screen
       to unlock it. Close it ourselves. */
    window.addEventListener('resize', lgDebounce(function () {
      var d = lgDrawer();
      if (!d || !d.hasAttribute('open')) return;
      if (window.innerWidth > 860 && document.body.classList.contains('fixed')) d.close();
    }, 150));
  }

  function boot(scope) {
    initHeadVar();
    initDropdowns(scope);
    initMore(scope);
    initFaq(scope);
    initFbar();
    initNavHide();
    initInfinite();
    initFacetOpener(scope);
    initFacetEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
